import { Checkbox, Menu } from "antd";
import { useEffect, useState } from "react";
import AuthZButton from "src/components/AuthzButton";

const DecisionDataIndex = "decision";
const DecisionReasonDataIndex = "decisionReason";

export function filterDecisionAndReasoningColumn(filter, record) {
  return (
    (filter.decisions.length === 0 ? true : filter.decisions.includes(record[DecisionDataIndex])) &&
    (filter.decisionReasons.length === 0
      ? true
      : filter.decisionReasons.includes(record[DecisionReasonDataIndex]?.id))
  );
}

function RenderOptions({ label, isChecked }) {
  return (
    <div>
      <Checkbox checked={isChecked} /> {label}
    </div>
  );
}

function RenderFilterSection({
  items,
  selectedFilters,
  setSelectedFilters,
  dataIndex,
  sectionTitle,
  getPopupContainer
}) {
  return (
    <div className="review-filter-section">
      <b>{sectionTitle}</b>
      <Menu
        items={items}
        multiple={true}
        onSelect={(props) => {
          setSelectedFilters(
            props.selectedKeys.map((selectedKey) => ({
              dataIndex: dataIndex,
              value: selectedKey,
            }))
          );
        }}
        onDeselect={(props) => {
          setSelectedFilters(
            props.selectedKeys.map((selectedKey) => ({
              dataIndex: dataIndex,
              value: selectedKey,
            }))
          );
        }}
        getPopupContainer={getPopupContainer}
        selectedKeys={selectedFilters.map((filter) => filter.value)}
      />
    </div>
  );
}

export function DecisionAndReasoningFilterDropdown({
  selectedKeys,
  setSelectedKeys,
  confirm,
  decisionFilters,
  reasonsAvailableForFilter,
  visible,
  getPopupContainer
}) {
  function extractCurrentlySelectedReasons() {
    return (
      selectedKeys[0]?.decisionReasons?.map((reason) => ({
        dataIndex: DecisionReasonDataIndex,
        value: String(reason),
      })) ?? []
    );
  }

  function extractCurrentlySelectedDecisions() {
    return (
      selectedKeys[0]?.decisions?.map((decision) => ({
        dataIndex: DecisionDataIndex,
        value: decision,
      })) ?? []
    );
  }

  function applySelectedKeys() {
    if (selectedDecisionsToBeFiltered.length === 0 && selectedReasonsToBeFiltered.length === 0) {
      setSelectedKeys([]);
    } else {
      setSelectedKeys([
        {
          decisions: selectedDecisionsToBeFiltered.map((filter) => filter.value) ?? [],
          decisionReasons:
            selectedReasonsToBeFiltered.map((filter) => parseInt(filter.value)) ?? [],
        },
      ]);
    }
    confirm();
  }

  const [selectedDecisionsToBeFiltered, setSelectedDecisionstoBeFiltered] = useState(
    extractCurrentlySelectedDecisions()
  );
  const [selectedReasonsToBeFiltered, setSelectedReasonsToBeFiltered] = useState(
    extractCurrentlySelectedReasons()
  );

  useEffect(() => {
    if (visible === false) {
      applySelectedKeys();
    }
  }, [visible]);

  return (
    <div className="review-decision-and-reasoning-filter-container">
      <RenderFilterSection
        items={decisionFilters.map((decisionFilter) => {
          return {
            key: decisionFilter.value,
            label: (
              <RenderOptions
                label={decisionFilter.text}
                isChecked={selectedDecisionsToBeFiltered.some(
                  (filter) => decisionFilter.value === filter.value
                )}
              />
            ),
          };
        })}
        selectedFilters={selectedDecisionsToBeFiltered}
        setSelectedFilters={setSelectedDecisionstoBeFiltered}
        dataIndex={DecisionDataIndex}
        sectionTitle="Decisions"
        getPopupContainer={getPopupContainer}
      />
      {reasonsAvailableForFilter.length > 0 ? (
        <RenderFilterSection
          items={reasonsAvailableForFilter.map((reason) => {
            return {
              key: String(reason.id),
              label: (
                <RenderOptions
                  label={reason.name}
                  isChecked={selectedReasonsToBeFiltered.some(
                    (filter) => reason.id === parseInt(filter.value)
                  )}
                />
              ),
            };
          })}
          selectedFilters={selectedReasonsToBeFiltered}
          setSelectedFilters={setSelectedReasonsToBeFiltered}
          dataIndex={DecisionReasonDataIndex}
          sectionTitle="Reasons"
          getPopupContainer={getPopupContainer}
        />
      ) : null}
      <div className="review-decision-and-reasoning-filter-footer">
        <div
          className="review-decision-and-reasoning-filter-reset"
          onClick={() => {
            setSelectedDecisionstoBeFiltered([]);
            setSelectedReasonsToBeFiltered([]);
          }}
        >
          Reset
        </div>
        <div className="review-decision-and-reasoning-filter-confirm">
          <AuthZButton buttonType="primary" onClick={applySelectedKeys}>
            OK
          </AuthZButton>
        </div>
      </div>
    </div>
  );
}
